import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from './_authenticated';

export const photoRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/photos/$photoId',
  component: PhotoDetailPage,
});

// Backward compatibility
export const Route = photoRoute;

function PhotoDetailPage() {
  const { photoId } = photoRoute.useParams();

  return (
    <div data-testid="photo-detail-page">
      <h1>Photo Details</h1>
      <p>Viewing photo: {photoId}</p>
    </div>
  );
}
